import { render } from "./ClassFooter.vue?vue&type=template&id=06791e48&scoped=true"
import script from "./ClassFooter.vue?vue&type=script&lang=ts"
export * from "./ClassFooter.vue?vue&type=script&lang=ts"

import "./ClassFooter.vue?vue&type=style&index=0&id=06791e48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06791e48"

export default script